import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";

const MessageInputMain = styled("div")(({ theme }) => ({
  height: "60px",
  backgroundColor: "#fff",
  border: "1px solid #E1E1E1",
  marginTop: "10px",
  display: "flex",
  alignItems: "center",
  padding: "0px 10px",
  position: "relative",
  form: {
    display: "flex",
    width: "100%",
    alignItems: "center",
  },
  [theme.breakpoints.down("lg")]: {
    padding: "0px 00px",
  },
  "& .Images_previews": {
    padding: "5px 10px",
    background: "#E1E1E1",
    position: "absolute",
    bottom: "100%",
    left: "0",
    width: "100%",
    height: "100px",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    overflow: "hidden",
    "& .previews_image": {
      position: "relative",
    },
    "& button": {
      padding: "0",
      border: "1px solid red",
      backgroundColor: "red",
      position: "absolute",
      top: "6px",
      right: "5px",
      svg: {
        fontSize: "15px",
        fill: "#fff",
      },
    },
    img: {
      width: "100px",
      height: "70px",
      borderRadius: "5px",
      objectFit: "cover",
    },
  },
}));
const InputMain = styled("div")(({ theme }) => ({
  height: "40px",
  padding: "10px",
  background: "#E1E1E1",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  width: "100%",
  "& input": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    border: "none",
    width: "100%",
    background: "transparent",
    "&:focus": {
      border: "none",
      outline: "none",
    },
  },
}));

const FileUploadButton = styled(IconButton)(({ theme }) => ({
  label: {
    height: "25px",
    cursor: "pointer",
  },
}));

export { InputMain, MessageInputMain, FileUploadButton };
